import { Case } from '@/@types/generated'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { EllipsisVerticalIcon } from 'lucide-react'
import DeleteCaseDialog from './dialogs/DeleteCaseDialog'
import React from 'react'

// Future actions will be added as union types
// e.g. | 'archive' | 'assign' | 'close'
export type CaseAction = 'delete'

interface CaseActionsProps {
  case: Case
  onDelete?: () => void
}

export default function CaseActions({
  case: _case,
  onDelete,
  ...props
}: CaseActionsProps &
  Omit<React.ComponentProps<'button'>, keyof CaseActionsProps>) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" {...props}>
          <EllipsisVerticalIcon />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-56" align="start">
        <DropdownMenuLabel>Case Actions</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DeleteCaseDialog case={_case} onDelete={() => onDelete?.()}>
          <DropdownMenuItem
            variant="destructive"
            onSelect={(e) => e.preventDefault()}
          >
            Delete Case
          </DropdownMenuItem>
        </DeleteCaseDialog>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
